import React from "react";
import {
  CheckCircleOutlined, CloseCircleOutlined,
  SyncOutlined, MinusCircleOutlined, StopOutlined,
  ClockCircleOutlined, PlayCircleOutlined, ExclamationCircleOutlined,
} from "@ant-design/icons";

const CONFIG = {
  Pass:                 { bg: "#EAF3DE", color: "#3B6D11",  icon: <CheckCircleOutlined />,  label: "Passed"   },
  Completed:            { bg: "#EAF3DE", color: "#3B6D11",  icon: <CheckCircleOutlined />,  label: "Passed"   },
  Success:              { bg: "#EAF3DE", color: "#3B6D11",  icon: <CheckCircleOutlined />,  label: "Success"  },
  Fail:                 { bg: "#FCEBEB", color: "#A32D2D",  icon: <CloseCircleOutlined />,  label: "Failed"   },
  Failed:               { bg: "#FCEBEB", color: "#A32D2D",  icon: <CloseCircleOutlined />,  label: "Failed"   },
  Error:                { bg: "#FAEEDA", color: "#854F0B",  icon: <MinusCircleOutlined />,  label: "Error"    },
  "Completed with Error":{ bg: "#FAEEDA", color: "#854F0B", icon: <MinusCircleOutlined />,  label: "With errors"},
  "In Progress":        { bg: "#E6F1FB", color: "#185FA5",  icon: <SyncOutlined spin />,    label: "Running"  },
  Running:              { bg: "#E6F1FB", color: "#185FA5",  icon: <SyncOutlined spin />,    label: "Running"  },
  Queued:               { bg: "#F1EFE8", color: "#5F5E5A",  icon: <MinusCircleOutlined />,  label: "Queued"   },
  Stopped:              { bg: "#F1EFE8", color: "#5F5E5A",  icon: <StopOutlined />,         label: "Stopped"  },
  // Fan-out outcomes. Partial = one branch failed while another passed, so it is neither
  // green nor red; Skipped = an upstream step failed, so this one never got its inputs.
  Partial:              { bg: "#FAEEDA", color: "#854F0B",  icon: <ExclamationCircleOutlined />, label: "Partial" },
  Skipped:              { bg: "#F1EFE8", color: "#888780",  icon: <MinusCircleOutlined />,  label: "Skipped"  },
  "Timed Out":          { bg: "#FAEEDA", color: "#854F0B",  icon: <ClockCircleOutlined />,  label: "Timed Out"},
  Started:              { bg: "#E6F1FB", color: "#185FA5",  icon: <PlayCircleOutlined />,   label: "Started"  },
  "Never run":          { bg: "#F1EFE8", color: "#888780",  icon: <MinusCircleOutlined />,  label: "Never run"},
};

/**
 * RunStatusBadge — reusable coloured badge for job/result status.
 *
 * Props:
 *   status  string  — job or test status string from backend
 *   size    "sm"|"md" — default "md"
 */
function RunStatusBadge({ status, size = "md" }) {
  const cfg = CONFIG[status] || { bg: "#F1EFE8", color: "#5F5E5A", icon: <MinusCircleOutlined />, label: status || "—" };
  return (
    <span style={{
      display: "inline-flex",
      alignItems: "center",
      gap: size === "sm" ? 3 : 4,
      background: cfg.bg,
      color: cfg.color,
      padding: size === "sm" ? "1px 8px" : "2px 10px",
      borderRadius: 20,
      fontSize: size === "sm" ? 11 : 12,
      fontWeight: 500,
      whiteSpace: "nowrap",
    }}>
      {cfg.icon}
      {cfg.label}
    </span>
  );
}

export default RunStatusBadge;
